// Module
var code = "<a class=\"br-link-1 text-ellipsis\" ui-sref=\"accounts-detail-demand.active-deliveries({id: $ctrl.account.id})\" ng-click=\"$event.stopPropagation();\" permission permission-only=\"'accounts.demand.get'\" permission-on-authorized=\"$root.enableElement\" permission-on-unauthorized=\"$root.disableElement\"> {{$ctrl.account.name}} </a> ";
// Exports
export default code;